const normalized = (path) => String(path || '').replace(/\\/g, '/').replace(/\/+$/, '');
const windowsPath = (path) => /^[A-Za-z]:|^[/\\]{2}/.test(String(path || '').trimStart());
const comparable = (path, root) => windowsPath(root) ? normalized(path).toLowerCase() : normalized(path);
const within = (path, root) => {
  const candidate = comparable(path, root);
  const base = comparable(root, root);
  return candidate === base || candidate.startsWith(`${base}/`);
};

const pathParts = (path) => normalized(path).split('/').filter(Boolean);

export const getPathRootLabel = (root, roots, translate) => {
  const baseLabel = (entry) => entry.kind === 'shared'
    ? entry.name || pathParts(entry.path).at(-1) || translate('workflow.paths.shared')
    : translate(`workflow.paths.${entry.kind}`);
  const label = baseLabel(root);
  const duplicates = roots.filter((entry) => baseLabel(entry) === label);
  if (duplicates.length < 2) return label;
  const parents = pathParts(root.path).slice(0, -1);
  for (let depth = 1; depth <= parents.length; depth += 1) {
    const detail = parents.slice(-depth).join(' › ');
    if (duplicates.every((entry) => entry === root
        || pathParts(entry.path).slice(0, -1).slice(-depth).join(' › ') !== detail)) {
      return `${label} · ${detail}`;
    }
  }
  return label;
};

export const resolveActionPathEdit = (value, root, roots = [], { relativeName = false, storageRelative = false } = {}) => {
  if (!value || !root || windowsPath(value) || /^[A-Za-z][A-Za-z\d+.-]*:\/\//.test(value)
      || (!storageRelative && value.startsWith('/'))
      || (!relativeName && /^\{/.test(value)) || roots.some((entry) => within(value, entry.path))) return value;
  const separator = root.includes('\\') ? '\\' : '/';
  return `${root.replace(/[/\\]+$/, '')}${separator}${value.replace(/^[/\\]+/, '').replace(/[/\\]/g, separator)}`;
};

export const presentActionPath = (value, roots = [], { storageRelative = false } = {}) => {
  const path = String(value || '');
  const primary = roots.find((root) => root.kind === 'storage');
  const matched = [...roots].sort((a, b) => b.path.length - a.path.length)
    .find((root) => within(path, root.path));
  const dynamic = /^\{/.test(path);
  const external = windowsPath(path) || (!storageRelative && path.startsWith('/'))
    || /^[A-Za-z][A-Za-z\d+.-]*:\/\//.test(path);
  const root = matched || (!dynamic && !external ? primary : null);
  const relative = matched ? normalized(path).slice(normalized(matched.path).length).replace(/^\/+/, '')
    : root ? path.replace(/^[/\\]+/, '') : dynamic ? path : pathParts(path).at(-1) || '';
  const display = root ? (relative.replace(/\\/g, '/') || (path ? '/' : '')) : relative;
  const fullPath = matched ? path : resolveActionPathEdit(path, root?.path, roots, { storageRelative });
  const parts = display.split('/').filter(Boolean);
  const name = dynamic ? path : parts.at(-1) || (path ? '/' : '');
  const parent = dynamic ? '' : parts.slice(0, -1).join(' › ');
  const parentPath = String(fullPath).replace(/[/\\][^/\\]*[/\\]*$/, '');
  const editRoot = dynamic ? undefined : display === '/' ? root?.path
    : parentPath || (fullPath.startsWith('/') ? '/' : undefined);
  return { root, display, name, parent, fullPath,
    editRoot: editRoot === fullPath ? root?.path : editRoot,
    kind: root?.kind || (dynamic ? 'dynamic' : 'saved_location') };
};
